import Error from 'next/error'
import { MetaSeo } from '../../components/index'
import { PAGINEDETAIL, CATEGORIEFAQ } from '../../utils/endpoint'
import { getApiClient } from '../../utils'
import React from 'react'
import PropTypes from 'prop-types'
import FAQPanel from '../../components/molecules/FAQPanel/FAQPanel'

const Faq = ({ page, statusCode, categorieFaq }) => {
  if (!page) return <Error statusCode={statusCode} />

  return (
    <>
      <FAQPanel categorieFaq={categorieFaq} page={page} />
    </>
  )
}

export async function getServerSideProps({ params, locale, req }) {
  const api = getApiClient(req)
  const pageResponse = await api.get(PAGINEDETAIL, { params: { chiave: 'faq', lang: locale } })
  const page = await pageResponse.data

  const categorieFaqResponse = await api.get(CATEGORIEFAQ, { params: { lang: locale } })
  const categorieFaq = await categorieFaqResponse.data

  const toolbarProps = { toolbarPage: page }
  return { props: { page, ...toolbarProps, categorieFaq } }
}

Faq.propTypes = { page: PropTypes.object, statusCode: PropTypes.number }

export default Faq
